import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from '@/react-query/api';

import { endpoints } from '../endpoints';

export const useSubmitWriteback = () => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (clinicalNoteId: string) => {
      return makeAPIRequestReactQuery(
        `/videa-notes/${clinicalNoteId}/writeback`,
        {},
        'post',
        {
          data: {},
          headers: {
            practice: currentPracticeId,
            org: currentOrganizationId,
          },
        },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries([
        endpoints.ambient.voiceNotes.batchNotesByUnifiedAppointmentIds,
      ]);
      queryClient.invalidateQueries([
        endpoints.ambient.voiceNotes.batchNotesByStandalonePatientVisitIds,
      ]);
    },
  });
};
